import type { Theme } from '~/theme';

const getColorForScore = ({
  theme,
  score,
}: {
  theme: Theme;
  score: number;
}) => {
  const tokens = theme.getTokens();

  if (score >= 99) return tokens.colors.leadScore['eq99'];
  if (score >= 90) return tokens.colors.leadScore['gte90'];
  if (score >= 70) return tokens.colors.leadScore['gte70'];
  if (score >= 50) return tokens.colors.leadScore['gte50'];
  if (score >= 30) return tokens.colors.leadScore['gte30'];
  return tokens.colors.leadScore['lt30'];
};
export default getColorForScore;
